import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Navbar from "./components/nav/Navbar";
import NavigationContext from "./contexts/NavigationContext";
import AddBook from "./pages/AddBook";
import BookStore from "./pages/BookStore";
import EditBook from "./pages/EditBook";
import "./styles/style.css";

function App() {
	const [navTab, setNavTab] = useState("BookStore");

	return (
		<BrowserRouter>
			<NavigationContext.Provider value={{ navTab, setNavTab }}>
				<Navbar />
				<Routes>
					<Route path="/" element={<BookStore />} />
					<Route path="add-book" element={<AddBook />} />
					<Route path="edit-book/:bookId" element={<EditBook />} />
				</Routes>
			</NavigationContext.Provider>
		</BrowserRouter>
	);
}

export default App;
